import './bootstrap/bootstrap';

function initStickyHeader() {
    const header = document.getElementById("header-section");
    if (!header || !header.classList.contains("site-header-sticky")) return;

    function setBodyPadding() {
	    document.body.style.paddingTop = header.offsetHeight + "px";
	}
	setBodyPadding();
	window.addEventListener("resize", setBodyPadding, { passive: true });

    const isType1 = header.classList.contains("header-section-type-1");
    const THRESHOLD_ADD    = isType1 ? 95 : 60;
    const THRESHOLD_REMOVE = isType1 ? 40 : 20;

    let isScrolled = false;
    let ticking    = false;

    function update() {
        const y = window.scrollY;

        if (!isScrolled && y > THRESHOLD_ADD) {
            isScrolled = true;
            header.classList.add("is-scrolled");
        } else if (isScrolled && y < THRESHOLD_REMOVE) {
            isScrolled = false;
            header.classList.remove("is-scrolled");
        }
    }

    window.addEventListener("scroll", () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { update(); ticking = false; });
    }, { passive: true });

    // Run once on load in case page is already scrolled
    update();
}

initStickyHeader();